import enFlag from "../assets/flags/en.svg";
import esFlag from "../assets/flags/es.svg";
import enTranslations from "../locales/en.json";
import esTranslations from "../locales/es.json";

export const DEFAULT_LANGUAGE = "es";

export const LANGUAGES = [
  {
    id: "es",
    code: "ES",
    labelKey: "language.spanish",
    flag: esFlag,
    translations: esTranslations,
  },
  {
    id: "en",
    code: "EN",
    labelKey: "language.english",
    flag: enFlag,
    translations: enTranslations,
  },
];

export const SUPPORTED_LANGUAGES = LANGUAGES.map(({ id }) => id);
